__turbopack_context__.v({
  "body_rich_text": "SocialSection-module-scss-module__mm-CYq__body_rich_text",
  "direction__column": "SocialSection-module-scss-module__mm-CYq__direction__column",
  "direction__row": "SocialSection-module-scss-module__mm-CYq__direction__row",
  "gradient-glow-blue": "SocialSection-module-scss-module__mm-CYq__gradient-glow-blue",
  "gradient-glow-neon": "SocialSection-module-scss-module__mm-CYq__gradient-glow-neon",
  "gradient-glow-orange": "SocialSection-module-scss-module__mm-CYq__gradient-glow-orange",
  "gradient-glow-pink": "SocialSection-module-scss-module__mm-CYq__gradient-glow-pink",
  "gradient-glow-snap-pea": "SocialSection-module-scss-module__mm-CYq__gradient-glow-snap-pea",
  "gradient-neon-pink": "SocialSection-module-scss-module__mm-CYq__gradient-neon-pink",
  "gradient-pink-blue": "SocialSection-module-scss-module__mm-CYq__gradient-pink-blue",
  "gradient-pink-orange": "SocialSection-module-scss-module__mm-CYq__gradient-pink-orange",
  "layout__content-leading": "SocialSection-module-scss-module__mm-CYq__layout__content-leading",
  "layout__content-trailing": "SocialSection-module-scss-module__mm-CYq__layout__content-trailing",
  "module-base": "SocialSection-module-scss-module__mm-CYq__module-base",
  "module-content-swap": "SocialSection-module-scss-module__mm-CYq__module-content-swap",
  "module_block__contained": "SocialSection-module-scss-module__mm-CYq__module_block__contained",
  "module_block__uncontained": "SocialSection-module-scss-module__mm-CYq__module_block__uncontained",
  "module_breadcrumbs": "SocialSection-module-scss-module__mm-CYq__module_breadcrumbs",
  "section__content": "SocialSection-module-scss-module__mm-CYq__section__content",
  "section__cta": "SocialSection-module-scss-module__mm-CYq__section__cta",
  "section__heading": "SocialSection-module-scss-module__mm-CYq__section__heading",
  "section__illustration": "SocialSection-module-scss-module__mm-CYq__section__illustration",
  "section__inner": "SocialSection-module-scss-module__mm-CYq__section__inner",
  "section__subtitle": "SocialSection-module-scss-module__mm-CYq__section__subtitle",
  "section__textBlock": "SocialSection-module-scss-module__mm-CYq__section__textBlock",
  "section_bg_fill__base": "SocialSection-module-scss-module__mm-CYq__section_bg_fill__base",
  "section_bg_fill__gradient": "SocialSection-module-scss-module__mm-CYq__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "SocialSection-module-scss-module__mm-CYq__section_bg_fill__no-fill",
  "section_bg_fill__raised": "SocialSection-module-scss-module__mm-CYq__section_bg_fill__raised",
  "section_container": "SocialSection-module-scss-module__mm-CYq__section_container",
  "with_breadcrumb": "SocialSection-module-scss-module__mm-CYq__with_breadcrumb",
  "with_navbar": "SocialSection-module-scss-module__mm-CYq__with_navbar",
});
